import React from 'react';

export default function Background() {
    return (
        <section className="background">
        </section>
    )
}